import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import VIPSection from './components/VIPSection';
import BookingForm from './components/BookingForm';
import Footer from './components/Footer';
import Admin from './components/Admin';
import SpecialServices from './pages/SpecialServices';
import GalleryPage from './pages/GalleryPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <VIPSection />
      <BookingForm />
      <Footer />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/special-services" element={<SpecialServices />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/builder" element={<Navigate to="/special-services" replace />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
